import React, { useState } from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import UIUtils from "utils/UIUtils";
import UIInputPW from 'components/input/inputPW';

function ContentsContainer() {
    const location = useLocation();
    const receivedData = (location.state as any)?.data;
    const history = useHistory();
    const [confirmPassword ,setConfirmPassword] = useState('');
    const [loginPassword ,setLoginPassword] = useState('');
    const [loginNm, setLoginNm] = useState('');
    const [userId, setUserId] = useState('');
    const [gubun, setGubun] = useState('');
    const loginForm = React.useRef<HTMLFormElement>(null);

    const formId = "loginForm";


    const tabClickHandler=(gubun:string) => {
        if(receivedData.GUBUN !== gubun ){
            let GUBUN = gubun;
            let dataToSend = {GUBUN}
            // 비밀번호 찾기 화면(1400)으로 이동
            history.push({
                pathname: './usr_1400',
                state: {data: dataToSend}
            });
        }
    };

    // 비밀번호 변경
    async function onClickSave(event) {

//         console.log(loginForm.current);
        console.log(confirmPassword);

        let param = {
            UPDT_USER_ID: userId,
            USER_ID: userId,
            LOGIN_NM: loginNm,
        }

        if(await UIUtils.confirm('저장하시겠습니까?')){

            const response:any = await CommonUtil.execute({
                url: "usr_1402.jct",
                form: loginForm.current as HTMLFormElement,
            }).then((response:any) => {
                if(response.ERR_CD =="9999"){
                    UIUtils.alert(response.ERR_MSG).then();
                    return;
                } else {
                    UIUtils.alert('비밀번호 변경이 완료되었습니다. \n  로그인해 주세요.').then(() => {
                    }).then(() => {
                        history.push({
                            pathname: '/main/usr_1000/usr_1300',
                        });
                    });;
                }
            }).catch((error) => {
                CommonUtil.showAxiosError(error);
                return;
            });

        }
    }

    const onClickCancel = () => {
        history.push({
            pathname: './usr_1300',
        });
    }

    React.useEffect(() => {

        if(receivedData != undefined){
            setGubun(receivedData.GUBUN);
            setLoginNm(receivedData.LOGIN_NM);
            setUserId(receivedData.USER_ID);
        } else {
            UIUtils.alert('잘못된 접근입니다.')
            .then(() => {
               history.push({pathname: '/main/usr_1000/usr_1400'});
            });
        }

    }, [])//effect

	return (
		<PageContainer session={false}>
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">로그인</Link></li>
				</ul>
				<main className="fww-main find-idpw-main">
					<div className="find-idpw">
						<h1 className="tx tx-hd2">아이디/비밀번호 찾기</h1>
						<ul className="tab-menu">
							<li className={gubun==='0' ? "active" : ""} onClick={()=>tabClickHandler('0')}><button type="button">아이디찾기</button></li>
							<li className={gubun==='1' ? "active" : ""} onClick={()=>tabClickHandler('1')}><button type="button">비밀번호찾기</button></li>
						</ul>
						<div className={ 'tab-cont' + (gubun==='0' ? ' active' : '') }>
							<div className="id-result">
								<p>아이디가 확인되었습니다.<br />로그인 화면으로 이동하여 로그인해주세요.</p>
								{loginNm != null ? (
                                    <p className="member-id">아이디 : <span className="fc-pri">{loginNm}</span></p>
                                ) : (
                                    <p className="member-id">조회 결과가 없습니다</p>
                                )}
							</div>

							<div className="hz-root hz-center hz-gap10">
								<Button color='pri' size="big" href="/main/usr_1000/usr_1300">로그인 하기</Button>
							</div>
						</div>
						<div className={ 'tab-cont' + (gubun==='1' ? ' active' : '') }>
							<form id={formId} name={formId} ref={loginForm}>
							    <UIInput type="hidden"
                                         attrs={{name: "LOGIN_NM"}}
                                         value={loginNm}
                                />
                                <UIInput type="hidden"
                                         attrs={{name: "USER_ID"}}
                                         value={userId}
                                />
								<div className="find-pw">
									<h4 className="mb15">비밀번호 재설정</h4>
									<div className="sub-txt mb30">비밀번호 재설정 후 이용하시기 바랍니다.</div>
									<div className="form-items mb40">
										<label className="mb15">비밀번호 입력</label>
										<UIInputPW
                                            className={'tf tf-big w100p'}
                                            placeholder={'새로운 비밀번호를 입력하세요'}
                                            attrs={{
                                                name: "LOGIN_PASSWORD",
                                                alt: "Password",
                                                tabIndex: 1,
                                                autoComplete: "on",
                                            }}
                                            readOnly={false}
                                            valueChanged={(value) => setLoginPassword(value)}
                                            rules={["required","password"]}
                                            focusClear={true}
                                        />
										<p className="tx-msg"><span className="fc-pri">※ 8~12자의 영문, 숫자 조합으로 입력해 주세요.</span></p>
									</div>
									<div className="form-items mb40">
										<label className="mb15">비밀번호 확인</label>
                                        <UIInputPW
                                            className={'tf tf-big w100p'}
                                            placeholder={'비밀번호를 한번 더 입력하세요'}
                                            attrs={{
                                                name: "CONFIRM_PASSWORD",
                                                alt: "Password",
                                                tabIndex: 2,
                                                autoComplete: "on",
                                            }}
                                            readOnly={false}
                                            valueChanged={(value) => setConfirmPassword(value)}
                                            rules={["required","password"]}
                                            focusClear={true}
                                        />
									</div>
									<div className="hz-root hz-center hz-gap10">
										<Button color='gray-o' size="big" onClick={() => onClickCancel()}>취소</Button>
										<Button color='pri' size="big" onClick={onClickSave}>저장</Button>
									</div>

								</div>
							</form>
							{/*
							<div className="information">
								<h3>안내</h3>
								<ul className="list-group">
									<li>이용자의 개인정보 보호를 위해 본인확인 절차가 필요합니다.</li>
									<li>정보통신망(2012.08.18 시행) 제23조 2(주민번호 사용제한) 규정에 따라 온라인 상 주민번호의 수집/이용을 제한합니다.</li>
									<li>입력하신 정보는 본인확인 용도 외 사용되거나 저장되지 않습니다.</li>
								</ul>
							</div>
							 */}
						</div>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;